import { Link, NavLink } from 'react-router-dom'
import './index.scss'
import * as React from 'react';
import LogoS from '../../assets/images/portfolio_logo.png'
import LogoSubtitle from '../../assets/images/bsg.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope, faHome, faUser, faCode } from '@fortawesome/free-solid-svg-icons'
import {
  faGithub,
  faHackerrank,
  faLinkedin,
} from '@fortawesome/free-brands-svg-icons'

const Sidebar = () => (
  <div className="nav-bar">
    <Link className="logo" to="/">
      <img src={LogoS} alt="logo" />
      <img className="sub-logo" src={LogoSubtitle} alt="BSG" />
    </Link>
    <nav>
      <NavLink exact="true" activeclassname="active" to="/">
        <FontAwesomeIcon icon={faHome} color="#210426" />
      </NavLink>
      <NavLink
        exact="true"
        activeclassname="active"
        className="about-link"
        to="/about"
      >
        <FontAwesomeIcon icon={faUser} color="#210426" />
      </NavLink>
      <NavLink 
        exact="true"
        activeclassname="active"
        className="projects-link"
        to='/projects'
        >
        <FontAwesomeIcon icon={faCode} color="#210426" />
      </NavLink>
      <NavLink
        exact="true"
        activeclassname="active"
        className="contact-link"
        to="/contact"
      >
        <FontAwesomeIcon icon={faEnvelope} color="#210426" />
      </NavLink>
    </nav>
    <ul>
      <li>
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.linkedin.com/in/blayne-gower-ii-11a6261b1/"
        >
          <FontAwesomeIcon icon={faLinkedin} color="#210426" />
        </a>
      </li>
      <li>
        <a target="_blank" rel="noreferrer" href="https://github.com/BlaSGoII">
          <FontAwesomeIcon icon={faGithub} color="#210426" />
        </a>
      </li>
      <li>
        <a
          target="_blank"
          rel="noreferrer"
          href="https://www.hackerrank.com/blayne_gower"
        >
          <FontAwesomeIcon icon={faHackerrank} color="#210426" />
        </a>
      </li>
    </ul>
  </div>
)

export default Sidebar
